import { Button } from '@radix-ui/themes'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserSession, selectUser, setCurrentPage } from '../../reducers/users'
import { navItems, navType } from '../../data/nav-items'
import { useEffect } from 'react'
import { useAppDispatch } from '../../reducers/store'
import { getRoles, permitsRole } from '../../utils/roles'
import { Collapsible } from './Collapsible'
import { useLocation, useNavigate } from 'react-router-dom'

function NavMenu() {
  const { session } = useSelector(selectUser)
  const dispatch = useDispatch()
  const di = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    di(fetchUserSession())
  }, [])

  const activeClass = (item: navType) => {
    if (item.type == 'DASHBOARD' && location.pathname == '/') {
      return 'bg-lightViolet text-menuPurple dark:text-mainText'
    }
    const basePath = '/' + item.type.toLowerCase()
    const regex = new RegExp(`^${basePath}(/|$)`)
    return regex.test(location.pathname)
      ? 'bg-lightViolet text-menuPurple dark:text-mainText'
      : 'bg-mainBackground text-mainText'
  }

  function navigatePage(page: string) {
    switch (page) {
      case 'DASHBOARD':
        navigate('/dashboard')
        break
      case 'ALERTS':
        navigate('/alerts')
        break
      case 'ACTIVITY':
        navigate('/activity')
        break
      case 'DEVICES':
        navigate('/devices')
        break
      case 'MEMBERS':
        navigate('/members')
        break
      case 'GROUPS':
        navigate('/groups')
        break
      case 'INTEGRATIONS':
        navigate('/integrations')
        break
      case 'BLOCKLIST':
        navigate('/blocklist')
        break
      case 'DEVICE-POLICIES':
        navigate('/device-policies')
        break
      case 'ADVERSARIES':
        navigate('/adversaries')
        break
      case 'TRAVEL':
        navigate('/travel')
        break
      case 'SSO_ERROR':
        navigate('/sso-error')
        break
      case 'INTEL-REPORTS':
        navigate('/intel-reports')
        break
      case 'VISUALIZATIONS':
        navigate('/visualizations')
        break
      case 'VICTIMOLOGY':
        navigate('/victimology')
        break
      case 'THREAT-HUNTER':
        navigate('/threat-hunter')
        break
      default:
        navigate('/dashboard')
        break
    }
  }

  const buttonItem = (item: navType, collapsibleItem: boolean) => {
    return (
      <Button
        key={item.type}
        variant="solid"
        size="3"
        className={`h-10 !w-[176px] text-[14px] justify-start cursor-pointer font-medium ${activeClass(item)} mb-1 text-sm`}
        onClick={() => {
          dispatch(setCurrentPage(item.type))
          navigatePage(item.type)
        }}
      >
        <div className={`${collapsibleItem ? 'ml-4' : ''}`}>{item.icon}</div>
        {item.display}
      </Button>
    )
  }

  const passAdditionalRequirements = (item: navType) => {
    if (item.additionalRequirements) {
      for (let i = 0; i < item.additionalRequirements.length; i++) {
        switch (item.additionalRequirements[i]) {
          case 'threatIntelAccess':
            if (!session?.portalPreferences?.threatIntelAccess) {
              return false
            }
            break
          case 'threatHunterAccess':
            if (!session?.portalPreferences?.threatHunterAccess) {
              return false
            }
            break
          case 'threatIntelEvaluation':
            if (session?.portalPreferences?.threatIntelEvaluation) {
              return false
            }
            break
          case 'sensitiveTravel':
            if (!session?.portalPreferences?.sensitiveTravel) {
              return false
            }
            break
        }
      }
    }
    return true
  }

  return (
    <>
      <div className="w-[176px] flex flex-col gap-1 flex-grow mx-4">
        {navItems.map((item) => {
          const roles = getRoles(session)
          if ((item.roles?.length > 0 && !permitsRole(roles, item.roles)) || !passAdditionalRequirements(item)) {
            return null
          } else if (item.items) {
            return (
              <div key={'menu_' + item.type} className="pt-3">
                <Collapsible title={item.display} paths={item.paths} icon={item.icon}>
                  {item.items.map((subItem) => {
                    if (
                      (subItem.roles?.length > 0 && !permitsRole(roles, subItem.roles)) ||
                      !passAdditionalRequirements(subItem)
                    ) {
                      return null
                    }
                    return <div key={subItem.type}>{buttonItem(subItem, true)}</div>
                  })}
                </Collapsible>
              </div>
            )
          }
          return buttonItem(item, false)
        })}
      </div>
    </>
  )
}

export default NavMenu
